import {
    Box,
    Button,
    HStack,
    Spacer,
    Divider,
    useDisclosure
} from '@chakra-ui/react';

import { CheckIcon, CloseIcon, DeleteIcon } from '@chakra-ui/icons';

import Const from '../Constants';

import TaskDetails from './TaskDetails';
import ConfirmDeleteDialog from './ConfirmDeleteDialog';

import { useTasksStore } from '../Stores/TasksStore';

const TaskDetailsBar = ({ auth, currentTask, setCurrentTask, setAppMode }) => {
  const handleUpdateTask_ = useTasksStore((state) => state.handleUpdateTask_);
  const handleDeleteTask = useTasksStore((state) => state.handleDeleteTask);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleConfirmDelete = async () => {
    const taskId = currentTask?.id;
    onClose();
    setCurrentTask(null);
    if (taskId) {
      await handleDeleteTask(auth, taskId);
    }
  };

  return (
    <Box
        width={Const.KTaskDetailsBarW}
        minW={Const.KTaskDetailsBarW}
        maxW={Const.KTaskDetailsBarW}
        background={Const.Gray46}
        padding={Const.SpaceMD}
        h={'100vh'}
        display='flex'
        flexDirection='column'
        overflow='hidden'
    >
        <HStack>
        <Button
            leftIcon={<CheckIcon/>}
            size={Const.SM}
            height={'30px'}
            background={ currentTask && currentTask.done ? Const.DoneColor : Const.Gray36}
            color={Const.Gray165}
            _hover={{ background: currentTask && currentTask.done ? Const.DoneLightColor : Const.Gray69 }}
            fontSize={Const.XS}
            onClick={() => {
                currentTask.done = !!!currentTask.done;
                setCurrentTask(currentTask);

                // Update only done status.
                handleUpdateTask_(auth, currentTask.id, null, null, currentTask.done); // TODO not working from UI
              }}
          >
              { currentTask && !currentTask.done ? 'Mark complete' : 'Completed' }
          </Button>
          <Spacer />
          <Button
            leftIcon={<DeleteIcon/>}
            iconSpacing={0}
            size={Const.SM}
            height={'30px'}
            background={Const.Gray31}
            color={Const.Gray165}
            _hover={{ background: Const.Red600 }}
            fontSize={Const.XS}
            onClick={onOpen}
          >
          </Button>
          <Button
            leftIcon={<CloseIcon/>}
            iconSpacing={0}
            size={Const.SM}
            height={'30px'}
            background={Const.Gray31}
            color={Const.Gray165}
            _hover={{ background: Const.Gray69 }}
            fontSize={Const.XXS}
            onClick={() => {
                setCurrentTask(null);
            }}
          >
          </Button>
        </HStack>
        <Divider
            my={4}
            borderColor={Const.SelectColor}
        />
        <Box flex={1} minH={0} overflow='hidden'>
            <TaskDetails
                auth={auth}
                mode={Const.sTaskDetailsBar}
                currentTask={currentTask}
                setCurrentTask={setCurrentTask}
                setAppMode={setAppMode}
            />
        </Box>

        <ConfirmDeleteDialog
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={handleConfirmDelete}
            title={'Delete task'}
            body={"Are you sure you want to delete this task? This can't be undone."}
        />
    </Box>
  );
};

export default TaskDetailsBar;
